import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import ResponsiveListContainer from '../../ResponsiveListContainer';
import GeneralDatePickerComponent from '../../components/GeneralDatePickerComponent';
import TitleComponent from './TitleComponent';
import { manualEntryMock, mockData } from './mock';
import SingleRow from './SingleRow';
import { useState } from 'react';
import Footer from './Footer';
import CertEntryModal from './CertEntryModal';
import ManualEntryModal from './ManualEntryModal';

const TopActions = (data, setData) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <span>פרטי חשבונית</span>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    height: 'fit-content',
                    padding: '0px 25px 0px 0px'
                }}
            >
                <Box component={'p'} sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                    תאריך מסמך
                </Box>
                <GeneralDatePickerComponent mainContent={data} setDisplayedData={setData} singleDateMode={true} />
            </Box>
        </Box>
    );
};

const renderSingleRow = (setManualEntryModal, setOpenCertModal) => (
    <SingleRow displayManualEntryModal={() => setManualEntryModal(true)} displayOpenCertModal={() => setOpenCertModal(true)} />
);

const NewReceiptMobileView = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id') || '1';
    const [data, setData] = useState(mockData);
    const [manualEntryModal, setManualEntryModal] = useState(false);
    const [openCertModal, setOpenCertModal] = useState(false);

    return (
        <>
            <ResponsiveListContainer
                topChips={() => TopActions(data, setData)}
                TitleComponent={TitleComponent}
                SingleRowComponent={() => renderSingleRow(setManualEntryModal, setOpenCertModal)}
                mainContent={data}
                displaySearch={false}
                FooterComponent={Footer}
                overflowState={false}
            />
            {openCertModal && <CertEntryModal data={manualEntryMock} dialogOpen={openCertModal} setDialogOpen={setOpenCertModal} />}
            {manualEntryModal && (
                <ManualEntryModal data={manualEntryMock} dialogOpen={manualEntryModal} setDialogOpen={setManualEntryModal} />
            )}
        </>
    );
};

export default NewReceiptMobileView;
